import Link from 'next/link'
import OriginPrice from './OriginPrice'
import SalePrice from './SalePrice'

interface PriceType {
  type?: string
  classes?: string
  link?: string
  priceAtWarehouse?: boolean
  hasGift?: boolean
  originPrice: number
  finalPrice: number
}

export const Price = ({
  type,
  classes,
  link = '',
  originPrice,
  finalPrice,
}: PriceType) => {
  const percent = Math.ceil(100 - (finalPrice / originPrice) * 100)
  return (
    <div className={`price-wrapper w-full mt-1 ${type ? type : ''}`}>
      <div className='flex items-center gap-1 leading-normal'>
        <OriginPrice originPrice={originPrice} classes={classes} type={type} />
        {percent > 0 && (
          <span className='discount flex w-max items-center rounded bg-pink-300/20 px-1 text-xs font-semibold leading-5 text-primary-base'>
            <span className='value'>{'-' + percent}</span>
            <span className='unit'>%</span>
          </span>
        )}
      </div>

      <Link href={link} className='flex items-center text-mainBody'>
        <SalePrice finalPrice={finalPrice} classes={classes} type={type} />
      </Link>
    </div>
  )
}

export default Price
